import { GrowthbookIfFeatureEnabled } from "components/growthbook/growthbook";
import { GrowthbookFeatures } from "components/growthbook/growthbook.types";
import useElementOnScreen from "hooks/use-element-on-screen/use-element-on-screen";
import { useRateClass } from "hooks/use-rate-class/use-rate-class";
import React, { useEffect, useRef } from "react";
import {
  kelasLiveEvents,
  LiveClassSections
} from "services/mixpanel/kelas-live-events";
import trackEvent from "services/mixpanel/mixpanel";
import { Spacer } from "styles/common/spacer";
import { CardCarousel } from "../card-carousel/card-carousel";
import RateClassCard from "./rate-class-card/rate-class-card";
import RateClassModal from "./rate-class-modal/rate-class-modal";
import { IRateClassesProps } from "./rate-classes.types";

const RateClasses: React.FC<IRateClassesProps> = ({
  primaryUser,
  showLatestPendingReviewModal
}) => {
  const {
    openRatingModal,
    pendingClassRatings,
    isModalOpen,
    closeRatingModal,
    modalData,
    metaData
  } = useRateClass({
    primaryUser,
    showLatestPendingReviewModal
  });

  const [containerRef, isVisible] = useElementOnScreen<HTMLDivElement>({
    root: null,
    rootMargin: "0px",
    threshold: 0.5
  });
  const isSectionViewedPreviously = useRef(false);
  const isClassRatingPending = pendingClassRatings.length !== 0;

  useEffect(() => {
    if (
      isClassRatingPending &&
      isVisible &&
      isSectionViewedPreviously.current === false
    ) {
      isSectionViewedPreviously.current = true;

      trackEvent({
        eventName: kelasLiveEvents.liveClassSectionViewed,
        payload: {
          sectionName: LiveClassSections.USER_FEEDBACK,
          cardsInSection: pendingClassRatings.length
        }
      });
    }
  }, [isVisible, isSectionViewedPreviously, isClassRatingPending]);

  if (!isClassRatingPending) {
    return null;
  }

  return (
    <GrowthbookIfFeatureEnabled feature={GrowthbookFeatures.UserFeedback}>
      <div ref={containerRef}>
        <CardCarousel
          title="Rating kelas"
          onScrollToNextPage={() => null}
          onScrollToPrevPage={() => null}>
          {pendingClassRatings.map((pendingClassRating) => (
            <RateClassCard
              key={pendingClassRating.id}
              onRatingClick={openRatingModal}
              data={pendingClassRating}
            />
          ))}
        </CardCarousel>
        <Spacer token={[16, 16, 80]} />
        {isModalOpen && modalData && (
          <RateClassModal
            data={modalData}
            onClose={closeRatingModal}
            primaryUser={primaryUser}
            metaData={metaData}
          />
        )}
      </div>
    </GrowthbookIfFeatureEnabled>
  );
};

export default RateClasses;
